import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/themeThree/search_icon.png'
import _imports_1 from '@/assets/common/loadMore.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "searchField" }
const _hoisted_3 = {
  class: "left_container",
  style: {"overflow-y":"scroll","height":"100%"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "groupText" }
const _hoisted_7 = {
  key: 0,
  class: "right_container"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","padding-top":"15%"}
}
const _hoisted_11 = ["src"]

import { ref, computed, onMounted, onBeforeUnmount, PropType, watch } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData, TAB_LIST } from '@/view/game/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import noDataImage from '@/assets/themeFour/searchNodata.png'

export default /*@__PURE__*/_defineComponent({
  __name: 'gamePopup',
  props: {
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
},
  emits: ['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup', 'onClickTab', 'searchGames', 'getGameTabData'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const localValue = ref('')
const props = __props
const active = ref(0);
const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const tabList = ref(TAB_LIST)
const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = __emit
const tabsRef = ref();
const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}
const close = () => {
    active.value = 0
    emits('close')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    emits('selectGroup', item)
}
const loadMoreGame = () => {
    emits('loadMoreGame')
}
const goToDeposit = () => {
    emits('goToDeposit')
}
const onClickTab = (value: any) => {
    active.value = value.name
    localValue.value = ''
    emits('onClickTab', value)
}
const getGameTabData = () => {
    if (active.value == 3) {
        emits('getGameTabData')
    }
}
const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any, favorite: number, favId: any) => {
    let data = {
        id: ID,
        makerId: makerID,
        isFavorite: favorite,
        favId: favId

    }
    emits('goToPlayGame', data)
}
const searchGames = () => {
    active.value = 0
    emits('searchGames', localValue.value)
}
watch(() => props.dataSet.show, (newVal) => {
    if (newVal) {
        setTimeout(() => {
            tabsRef.value?.resize();
        }, 100);
    }
});
__expose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    position: "right",
    style: {
        width: '100%',
        height: '100%',
        zIndex: '9998',
        overflow: 'hidden'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: "Slot",
          isPopupCloseBackIcon: true,
          onClosePopup: close
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_field, {
            modelValue: localValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
            type: "text",
            placeholder: _ctx.$t('home.searchGames'),
            class: "custom-field"
          }, {
            "right-icon": _withCtx(() => [
              _createElementVNode("div", {
                class: "left-section",
                onClick: searchGames
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  width: "15%",
                  style: {"opacity":"0.4"}
                }, null, -1)
              ]))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_van_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              style: {"height":"80%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.groupList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: _normalizeClass(["game_menu_item", __props.dataSet?.activeItem === item.id ? 'active_group' : '']),
                      onClick: ($event: any) => (selectGroup(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.icon,
                        alt: ""
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(item.name)), 1)
                    ], 10, _hoisted_4))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "18",
              class: "rightSide"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tabs, {
                  active: active.value,
                  "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
                  ref_key: "tabsRef",
                  ref: tabsRef,
                  sticky: "",
                  ellipsis: false,
                  onClickTab: onClickTab
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_tab, {
                        key: index,
                        title: _ctx.$t(item.name),
                        name: item.id
                      }, null, 8, ["title", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["active"]),
                (__props.dataSet?.gameList?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_van_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.gameList, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_col, {
                              span: "8",
                              class: "game_item",
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(GameCard, {
                                  gameImage: item.customIcon,
                                  onClickGameCard: ($event: any) => (goToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                                  gameTypeId: item.id,
                                  gameIsFavorite: item.isFavorite,
                                  onUpdateGameCategories: getGameTabData
                                }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      (__props.dataSet?.gameList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (__props.dataSet.activeItem != 'fav')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (!__props.dataSet?.loading && __props.dataSet?.showLoadMore)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "load_more_btn",
                                        onClick: loadMoreGame
                                      }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('common.loadMore')) + " ", 1),
                                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                                          src: _imports_1,
                                          alt: ""
                                        }, null, -1))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (__props.dataSet?.loading)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "loading_btn",
                                        onClick: loadMoreGame
                                      }, [
                                        _createVNode(_component_van_loading, { size: "20" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _unref(noDataImage),
                        alt: "",
                        width: "60%"
                      }, null, 8, _hoisted_11)
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})